import React, { useEffect, useState } from "react";
import Image from "components/image";
import { useWindowDimensions } from "helpers/useWindowDimensions";
import Button from "helpers/button";

const defaultStyle = "after:w-8 after:h-8";

const tabletDown =
  " md:after:rotate-90 md:after:-bottom-3 md:after:left-1/2 md:after:translate-y-full md:after:-translate-x-1/2";

const tabletLeft =
  " md:after:-left-3 md:after:right-auto md:after:-translate-x-full";

const mobileBottom =
  " sm:after:rotate-90 sm:after:-bottom-3 sm:after:left-1/2 sm:after:translate-y-full sm:after:-translate-x-1/2";

const bottomArrow =
  " after:rotate-90 after:-bottom-3 after:left-1/2 after:translate-y-full after:-translate-x-1/2";

const rightArrow =
  " after:-right-4 after:bottom-1/2 after:translate-x-full after:translate-y-1/2";

const leftArrow =
  " after:-right-4 after:bottom-1/2 after:translate-x-full after:rotate-180 after:translate-y-1/2";

const Process = ({ data }) => {
  const { width } = useWindowDimensions();

  const [process, setProcessOrder] = useState(data.content);
  const [screen, setScreen] = useState("");

  const generateClasses = (index) => {
    if (index == 0) return defaultStyle + rightArrow + mobileBottom;
    if (index == 1)
      return defaultStyle + rightArrow + mobileBottom + tabletDown;
    if (index == 2) return defaultStyle + bottomArrow;
    if (index == 3) return defaultStyle + leftArrow + mobileBottom + tabletLeft;
    if (index == 4)
      return defaultStyle + leftArrow + mobileBottom + " md:after:rotate-0";

    return "after:hidden";
  };

  useEffect(() => {
    if (width >= 1024 && screen !== "Desktop") setOrderDesktop();
    if (width > 768 && width < 1025 && screen !== "Tablet") setOrderTablet();
    if (width <= 768 && screen !== "Mobile") setOrderMobile();
  }, [width]);

  const setOrderDesktop = () => {
    const processCopy = [...data.content];
    [processCopy[5], processCopy[3]] = [processCopy[3], processCopy[5]];
    setProcessOrder(processCopy);
    setScreen("Desktop");
  };

  const setOrderTablet = () => {
    const processCopy = [...data.content];
    [processCopy[2], processCopy[3]] = [processCopy[3], processCopy[2]];
    setProcessOrder(processCopy);
    setScreen("Tablet");
  };

  const setOrderMobile = () => {
    setProcessOrder(data.content);
    setScreen("Tablet");
  };

  return (
    <div className="">
      <div className="container ">
        <div className="text-center max-w-lg mx-auto">
          <h2 className="font-display font-bold text-6xl sm:text-h2 text-gray-900 mb-3">
            {data.title}
          </h2>
          <p className="paragraph text-gray-600">{data.description}</p>
        </div>
        <div className="mt-16 sm:mt-10 grid grid-cols-3 gap-14 sm:grid-cols-1 md:grid-cols-2">
          {process.map(({ title, description, icon }, index) => (
            <div
              key={title}
              className={`bg-gray-200 p-8 pr-14 sm:px-5 sm:py-8 relative rounded-md border border-solid border-gray-300 after:content-arrow after:absolute ${generateClasses(
                index
              )}`}
            >
              <div className="w-6 h-6 after:right">
                <Image
                  image={icon.asset}
                  alt={icon.alt}
                  className="w-full h-full"
                />
              </div>
              <h3 className="my-4 font-sans text-h3 font-bold text-gray-800">
                {title}
              </h3>
              <p className="paragraph-normal leading-6 text-gray-700">
                {description}
              </p>
            </div>
          ))}
        </div>
        {data?.button && (
          <div className="mt-7 flex items-center justify-center">
            <Button button={data.button} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Process;
